<template>
  <div>    
    <HomeTopSlider />
    <HomeAboutClinic/>
    <HomeNewsSlider/>
    <HomeVideoSlider/>
    <div v-if="isLoaded">
      <HomeBoxes /> 
    </div>
    <HomeMobileBottomBar />  
  </div>
</template>

<script>
import HomeIntro from '../partial/HomeIntro'
import HomeBoxes from '../partial/HomeBoxes'
import HomeCallAction from '../partial/HomeCallAction'
import HomeServices from '../partial/HomeServices'
import HomeTeam from '../partial/HomeTeam'
import HomeWorks from '../partial/HomeWorks'
import HomeVideoSlider from '../partial/HomeVideoSlider'
import HomeNewsSlider from '../partial/HomeNewsSlider'
import HomePricing from '../partial/HomePricing'
import HomePartners from '../partial/HomePartners'
import HomeTopSlider from '../partial/HomeTopSlider'
import HomeAboutClinic from '../partial/HomeAboutClinic'
import HomeMobileBottomBar from '../partial/HomeMobileBottomBar'
// import { getDataFromServer } from '../utils/DataProvider'
// import { InitSource } from '../sources/language_provider'

export default {
  data:() => {
    return{
      isLoaded: false,
    }
  },
  components: {
    HomeIntro, 
    HomeBoxes,
    HomeCallAction,
    HomeServices,
    HomeTeam,
    HomeWorks,
    HomeVideoSlider,
    HomeNewsSlider,
    HomePricing,
    HomePartners,
    HomeTopSlider,
    HomeAboutClinic,
    HomeMobileBottomBar,
  },
  methods: {
    lodaded(){
      console.log("lodaded boxes ============================ SET_CURRENT_LANGUAGE ", this.$store.getters.CURRENT_LANGUAGE) 
       if(this.$store.getters.CURRENT_LANGUAGE !== ''){
        this.isLoaded = true
       }else{
         this.isLoaded = false
       }
    },
  },  
  created(){   
    this.lodaded();
    this.$store.subscribe((mutation, state) => {
          if(mutation.type === 'SET_CURRENT_LANGUAGE'){
             console.log("created footer subscribe SET_CURRENT_LANGUAGE")           
             this.lodaded();        
          }
      }) 
  }  
}

</script>

<style scoped>

</style>
